import React from "react";
import GridItem from "./CGridItem";
import GridContainer from "./CGContainer";
const Grid = ({ children, gap = 16, className, xxs, xs, md, lg, item = false ,style}) => {
  return item ? (
    <GridItem
      children={children}
      className={className}
      xxs={xxs}
      xs={xs}
      md={md}
      lg={lg}
      style={style}
    />
  ) : (
    <GridContainer children={children} className={className} gap={gap} style={style}/>
  );
};

export default Grid;